module.exports = __webpack_public_path__ + "static/media/ig.26b42da8.svg";